// @mui
import PropTypes from 'prop-types';
import { alpha, styled } from '@mui/material/styles';
import { Card, Typography } from '@mui/material';

// utils
// components
import Iconify from '../../../components/iconify';

// ----------------------------------------------------------------------

const StyledIcon = styled('div')(({ theme }) => ({
    margin: 'auto',
    display: 'flex',
    borderRadius: '50%',
    alignItems: 'center',
    width: theme.spacing(12),
    height: theme.spacing(12),
    boxShadow: theme.customShadows.z8,
    justifyContent: 'center',
    marginBottom: theme.spacing(3),
}));

// ----------------------------------------------------------------------

AppWidgetSummary.propTypes = {
    color: PropTypes.string,
    icon: PropTypes.string,
    title: PropTypes.string.isRequired,
    sx: PropTypes.object,
};

export default function AppWidgetSummary({ onClick, title, icon, color = 'primary', to = '/', sx, ...other }) {
    return (
        <Card
            onClick={onClick}
            sx={{
                py: 5,
                boxShadow: 0,
                cursor: 'pointer',
                boxShadow: (theme) => theme.customShadows.z8,
                textAlign: 'center',
                color: (theme) => theme.palette.common.black,

                bgcolor: (theme) => theme.palette[color].contrastText,
                ...sx,
            }}
            {...other}
        >
            <StyledIcon
                sx={{
                    color: (theme) => theme.palette[color].dark,
                    backgroundImage: (theme) =>
                        `linear-gradient(135deg, ${alpha(theme.palette[color].colorBackground, 0)} 0%, ${alpha(
                            theme.palette[color].colorBackground,
                            0.2
                        )} 100%)`,
                }}
            >
                <Iconify icon={icon} width={45} height={45} />
            </StyledIcon>

            <Typography variant="subtitle1" sx={{ opacity: 1 }}>
                {title}
            </Typography>
        </Card>
    );
}
